import React from "react"
import { Col } from "antd"
import { useStaticQuery, graphql } from "gatsby"
import style from "./Footer.module.scss"

export default () => {
  const { ctf } = useStaticQuery(graphql`
    query {
      ctf: contentfulHotel(name: { eq: "Residences at Biltmore" }) {
        ...HotelIconSVG
      }
    }
  `)

  const colProps = {
    className: style.topColumn,
    span: 24,
  }

  const { description, file } = ctf.icon

  return (
    <Col {...colProps}>
      <img
        alt="The logo for Residences at Biltmore - A StaySRG Destination"
        src="/RAB-StaySRG-color.svg"
        style={{ margin: `1rem auto`, maxWidth: 250, width: `90vw` }}
        width={250}
      />
    </Col>
  )
}
